module.exports = __webpack_public_path__ + "img/discuss.c6b1387.svg";